import { IConfigurableSvgProps } from "./interfaces";

export const CheckVoucherSvg: React.FC<IConfigurableSvgProps> = ({ strokeColor = "#000000" }) => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 9V23"
			stroke={strokeColor}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6 19.8102C5.99997 19.631 6.06189 19.4573 6.17528 19.3186C6.28867 19.1798 6.44654 19.0845 6.62214 19.0489C7.32481 18.9053 7.95632 18.5235 8.40986 17.9679C8.86339 17.4123 9.11111 16.7172 9.11111 16C9.11111 15.2828 8.86339 14.5877 8.40986 14.0321C7.95632 13.4765 7.32481 13.0947 6.62214 12.9511C6.44654 12.9155 6.28867 12.8202 6.17528 12.6814C6.06189 12.5427 5.99997 12.369 6 12.1898V9.77778C6 9.5715 6.08194 9.37367 6.22781 9.22781C6.37367 9.08194 6.5715 9 6.77778 9H25.4444C25.6507 9 25.8486 9.08194 25.9944 9.22781C26.1403 9.37367 26.2222 9.5715 26.2222 9.77778V12.1898C26.2223 12.369 26.1603 12.5427 26.0469 12.6815C25.9336 12.8202 25.7757 12.9155 25.6001 12.9511C24.8974 13.0947 24.2659 13.4765 23.8124 14.0321C23.3588 14.5877 23.1111 15.2828 23.1111 16C23.1111 16.7172 23.3588 17.4124 23.8124 17.9679C24.2659 18.5235 24.8974 18.9053 25.6001 19.0489C25.7757 19.0845 25.9336 19.1798 26.0469 19.3186C26.1603 19.4573 26.2223 19.631 26.2222 19.8102V22.2222C26.2222 22.4285 26.1403 22.6263 25.9944 22.7722C25.8486 22.9181 25.6507 23 25.4444 23H6.77778C6.5715 23 6.37367 22.9181 6.22781 22.7722C6.08194 22.6263 6 22.4285 6 22.2222V19.8102Z"
			stroke={strokeColor}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
